<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Đề thi Trắc nghiệm</h2>
        <div>
          <el-button @click="createMultipleChoiceManual" size="small" type="success">Tạo đề thi thủ công</el-button>
          <el-button @click="createModel" size="small" type="info">Thêm mới</el-button>
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Chọn trạng thái" class="input-select">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="8">
        </el-col>
        <el-col :span="2">
        </el-col>
        <el-col :span="2">
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Tổng số: <strong>{{ table.pagination.total }}</strong> đề thi
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
          width="80"
            label="STT">
            <template slot-scope="scope">
              <span>Bài {{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="image"
            width="180"
            align="center"
            label="Ảnh khóa học">
            <template slot-scope="scope">
              <img v-if="scope.row.image_path" :src="scope.row.image_path" class="course-image">
            </template>
          </el-table-column>
          <el-table-column
            label="Tên bài">
            <template slot-scope="scope">
              <span>Tên đề: <span style="color: green; font-size: 16px;">{{ scope.row.name }}</span></span>
              <p>Kiểu đề: {{ scope.row.type_time_txt }}</p>
              <p>Hình thức: <span style="color: green; font-size: 16px;">{{ scope.row.type_txt }}</span></p>
            </template>
          </el-table-column>
          <el-table-column
            width="250"
            label="Danh mục">
            <template slot-scope="scope">
              <span>{{ scope.row.category_test_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <!-- <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>

    <!-- preview dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      top="20px"
      width="85%">
      <div v-loading="dialogloading">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="questions-list-preview">
              <div class="item-question" v-for="(question, indexQuestion) in modelQuestions" :key="indexQuestion">
                <div>
                  <strong>Câu {{ indexQuestion + 1 }} : </strong>
                  <strong v-html="question.text"></strong>
                </div>
                <div class="list-options test-options" v-if="question.type_question == 1">
                  <ul class="answers">
                    <li class="answer-items" v-for="(option, index) in question.options" :key="index">
                      <label v-if="option.is_answer" style="color: green">
                        {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                      </label>
                      <label v-else>
                        {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small" plain type="info">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Lesssons',
  metaInfo () {
    return {
      title: 'Đề thi trắc nghiệm'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      dialogVisible: false,
      modelQuestions: '',
      dialogloading: false,
      dialogTitle: '',
      filter: {
        q: '',
        status: '',
        type: [2,3],
        course_id: 0,
        chapter_id: 0,
        page: 1,
        limit: 200,
        sort: 'id:1',
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ]
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        }
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'test-kits-online-index', text: 'Đề thi trắc nghiệm' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'test-kits-online-create', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Nút tạo đề thi thủ công
    createMultipleChoiceManual () {
      this.$router.push({name: 'multiple-choice-manual-create', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Nút tạo Model
    createModelTestKit () {
      this.$router.push({name: 'test-kits-online-create', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('test-kits', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      if (model.type == 3) {
        this.dialogVisible = true;
        // Tải dữ liệu Model xuống
        this.canSubmit = false
        let data = {
              'status': 1,
              'limit': -1,
              'question_ids': model.list_question_ids,
            }
        this.dialogloading = true
        this.modelQuestions = ''
        this.dialogTitle = model.name + ' (' + model.total_question + ' câu)'
        axios.get('questions', {params: data}).then(response => {
          switch (response.code) {
            case 200:
              this.modelQuestions = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
          this.dialogloading = false
        })
      } else {
        this.$router.push({name: 'test-kits-online-show', params: {id: model.id}})
      }
    },
    updateModel (model) {
      if (model.type == 3) {
        this.$router.push({name: 'multiple-choice-manual-update', params: {id: model.id}})
      } else {
        this.$router.push({name: 'test-kits-online-update', params: {id: model.id}})
      }

    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('test-kits/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa bài học: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('test-kits/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 60px;
  border-radius: 2px;
}

ul {
  list-style-type: none;
}

.questions-list-preview {
  height: 720px;
  overflow-y: scroll;
}
.answers {
  list-style-type: none;
  padding-left: 0;
  margin-top: 0;
  text-align: left !important;
  font-size: 14px;
}
.question {
  font-weight: bold;
  margin-bottom: 5px;
  text-align: left !important;
  font-size: 14px;
}
.answer-items {
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/test-kits-online/Index.vue